import type { SourceReference } from "@moneymap/domain";

export const INDIA_SOURCES: Readonly<Record<string, SourceReference>> = {
  "rbi-financial-planning": {
    id: "rbi-financial-planning",
    title: "I Can Do: Financial Planning",
    publisher: "Reserve Bank of India",
    url: "https://www.rbi.org.in/FinancialEducation/content/I%20Can%20Do_RBI.pdf",
    reviewedOn: "2026-09-07",
    appliesTo: "IN"
  },
  "irdai-health": {
    id: "irdai-health",
    title: "Health insurance consumer guidance",
    publisher: "Insurance Regulatory and Development Authority of India",
    url: "https://irdai.gov.in/health-dept",
    reviewedOn: "2026-09-07",
    appliesTo: "IN"
  },
  "irdai-life": {
    id: "irdai-life",
    title: "Life insurance and term-insurance consumer guidance",
    publisher: "Insurance Regulatory and Development Authority of India",
    url: "https://irdai.gov.in/life3",
    reviewedOn: "2026-09-07",
    appliesTo: "IN"
  },
  "pmjay": {
    id: "pmjay",
    title: "Ayushman Bharat PM-JAY",
    publisher: "National Health Authority",
    url: "https://nha.gov.in/PM-JAY",
    reviewedOn: "2026-09-07",
    appliesTo: "IN"
  },
  "dicgc": {
    id: "dicgc",
    title: "Deposit insurance FAQs",
    publisher: "Deposit Insurance and Credit Guarantee Corporation",
    url: "https://www.dicgc.org.in/FAQs",
    reviewedOn: "2026-08-30",
    appliesTo: "IN"
  },
  "sebi-adviser": {
    id: "sebi-adviser",
    title: "Understanding Investment Advisers",
    publisher: "Securities and Exchange Board of India",
    url: "https://investor.sebi.gov.in/investment_advisor.html",
    reviewedOn: "2026-08-30",
    appliesTo: "IN"
  }
};

export function getIndiaSource(id: string): SourceReference | undefined {
  return INDIA_SOURCES[id];
}
